// *codex:generated at 04-November-2026 - Ezytrack 插件设置 SUPERUSER_ONLY_ADMIN 打开时，只有 Superuser 可进入 User Settings*
import type { ReactNode } from 'react';
import { useShallow } from 'zustand/react/shallow';

import PermissionDenied from '../../components/errors/PermissionDenied';
import { useUserState } from '../../states/UserState';

/** The Ezytrack plugin reports `superuser_only_admin` in /api/user/me/. */
export function canOpenUserSettings(user: any): boolean {
  if (!user) return false;
  return !(user.superuser_only_admin && !user.is_superuser);
}

/** Route guard for /settings/user/*. */
export function UserSettingsGuard({ children }: { children: ReactNode }) {
  const [user] = useUserState(useShallow((state) => [state.user]));
  if (!user) return null;
  return canOpenUserSettings(user) ? <>{children}</> : <PermissionDenied />;
}
